import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Typography from '../../atoms/typography';
import Picture from '../../atoms/cms-picture';
import Ruler from '../../atoms/ruler';

const Title = styled(Typography)`
  margin-bottom: ${(props) => props.theme.modularScale['2xlarge']};
  text-align: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.brand};
  letter-spacing: .24em;
`;

const AboutCopy = styled(Typography)`
  margin: ${(props) => props.theme.modularScale['2xlarge']} auto;
  text-align: center;
  color: ${(props) => props.theme.color.brand};
  max-width: 720px;
  line-height: 40px;

  a {
    display: inline;
  }
`;

const AboutImage = styled(Picture)`
  margin: ${(props) => props.theme.modularScale['3xlarge']} auto 0;
  width: 150px;

  img {
    border-radius: 9999px;
  }
`;

const About = (props) => (
  <>
    <Title element="h2" like="dec-1">
      {props.data.title}
    </Title>

    <AboutCopy element="p" like="heading-4" dangerouslySetInnerHTML={{ __html: props.data.copy }} />
    {/* //TODO: update when we have image data */}
    {props.data?.image
      && <AboutImage {...props.data.image} alt={props.data.image_alt} />}
    {props.data?.hr && <Ruler />}
  </>
);

About.propTypes = {
  data: PropTypes.object.isRequired
};

About.whyDidYouRender = true;

export default About;
